import styled from "styled-components";
import AnimateBrick from "./AnimateBrick";

const StyledAnimateBrick = styled(AnimateBrick)`
  box-sizing: border-box;
  border: 1px solid #000;
`;

export default StyledAnimateBrick;
